export default function PrivacyPolicy() {
  return (
    <div className="container my-5">
    <div className="bg-white p-5 shadow rounded-3 border" style={{ maxWidth: "1000px", margin: "auto" }}>
      <h1 className="text-center mb-4">Privacy Policy</h1>
      <p className="text-end text-muted">Effective Date: April 11, 2025</p>

      <p><strong>Company Name:</strong> Shreenath</p>
      <p><strong>Tagline:</strong> Grow for a better future</p>
      <p><strong>Website:</strong> <a href="https://portal.shreenaths.com" target="_blank" rel="noopener noreferrer">https://portal.shreenaths.com</a></p>

      <hr />

      <h4 className="mt-4 fw-bold">1. Introduction</h4>
      <p>
        Shreenath ("we", "our", or "us") values your privacy. This Privacy Policy outlines how we collect, use, store,
        and protect your information when you use our mobile app and ERP services related to solar projects and asset
        management.
      </p>

      <h4 className="mt-4 fw-bold">2. Information We Collect</h4>
      <ul>
        <li><strong>Personal Information:</strong> Full name, email, phone number, location data, employee ID, and job title.</li>
        <li><strong>Project Data:</strong> Information about sites, vendors, machinery, and inventory.</li>
        <li><strong>Usage Data:</strong> Actions taken within the app, attendance logs, and leave records.</li>
        <li><strong>Device Data:</strong> Device type, OS version, IP address, and crash reports.</li>
      </ul>

      <h4 className="mt-4 fw-bold">3. How We Use Your Data</h4>
      <ul>
        <li>Facilitate role-based access and user-specific experiences.</li>
        <li>Track attendance, manage payroll, and handle HR functions.</li>
        <li>Assign and manage tasks, projects, and maintenance operations.</li>
        <li>Improve our services through performance analytics.</li>
      </ul>

      <h4 className="mt-4 fw-bold">4. Sharing of Information</h4>
      <p>We do not sell or share your personal data with third parties except:</p>
      <ul>
        <li>With your employer or company admin (as applicable).</li>
        <li>With service providers involved in hosting or app maintenance.</li>
        <li>As required by law or governmental authorities.</li>
      </ul>

      <h4 className="mt-4 fw-bold">5. Data Security</h4>
      <p>
        We implement industry-standard security practices such as encrypted data transmission (SSL), secure access
        controls, and frequent audits to ensure the protection of your data.
      </p>

      <h4 className="mt-4 fw-bold">6. Your Rights</h4>
      <ul>
        <li>View and update your personal information.</li>
        <li>Request deletion of your account or data.</li>
        <li>Opt-out of non-essential notifications.</li>
      </ul>

      <h4 className="mt-4 fw-bold">7. Children’s Privacy</h4>
      <p>
        Our service is not intended for individuals under the age of 18. We do not knowingly collect personal information
        from minors.
      </p>

      <h4 className="mt-4 fw-bold">8. Changes to This Policy</h4>
      <p>
        We may update this policy from time to time. Any changes will be communicated via the app or website.
      </p>

      <h4 className="mt-4 fw-bold">9. Contact Us</h4>
      <p>For any privacy-related concerns, contact us at:</p>
      <ul>
        <li>📧 <a href="mailto:pkk@shreenaths.com">pkk@shreenaths.com</a></li>
        <li>🌐 <a href="https://portal.shreenaths.com" target="_blank" rel="noopener noreferrer">https://portal.shreenaths.com</a></li>
      </ul>
    </div>
  </div>
  );
}
